import { render, staticRenderFns } from "./edit-organizer-message.vue?vue&type=template&id=1fea8225&scoped=true"
import script from "./edit-organizer-message.vue?vue&type=script&lang=js"
export * from "./edit-organizer-message.vue?vue&type=script&lang=js"
import style0 from "./edit-organizer-message.vue?vue&type=style&index=0&id=1fea8225&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fea8225",
  null
  
)

export default component.exports